import { render } from "./HowToPanel .vue?vue&type=template&id=f940dd46&scoped=true&ts=true"
import script from "./HowToPanel .vue?vue&type=script&lang=ts"
export * from "./HowToPanel .vue?vue&type=script&lang=ts"

import "./HowToPanel .vue?vue&type=style&index=0&id=f940dd46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f940dd46"]])

export default __exports__